@import 'core';

@import 'ads-alert.animations.scss';

/**
 * @prop --ads-alert-background-color: Background color
 * @prop --ads-alert-background-color-danger: Danger background color
 * @prop --ads-alert-background-color-success: Success background color
 * @prop --ads-alert-background-color-warning: Warning background color
 *
 * @prop --ads-alert-color: Text color
 * @prop --ads-alert-color-danger: Danger text color
 * @prop --ads-alert-color-success: Success text color
 * @prop --ads-alert-color-warning: Warning text color
 *
 * @prop --ads-alert-z-index: Z-index layer height
 */

::slotted(*) {
  display: inline-block !important;
}

:host {
  display: block;
  position: relative;
  width: 100%;
  z-index: var(--ads-alert-z-index, $ads-alert-z-index);
}

:host([theme='default']) {
  @include ads-vars-component-alert-default;
}

:host([theme='dark']) {
  @include ads-vars-component-alert-dark;
}

:host([dir='ltr']) {
  @include ads-vars-component-alert-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-alert-rtl;
}

.c-alert {
  background-color: var(--ads-alert-background-color, $ads-alert-background-color);
  box-sizing: border-box;
  color: var(--ads-alert-color, $ads-alert-color);
  fill: var(--ads-alert-color, $ads-alert-color);
  display: block !important;
  max-height: $ads-alert-animation-max-height;
  opacity: 1;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: inherit;

  &.is-closed {
    pointer-events: none;
  }

  &.is-hidden {
    display: none !important;
  }

  &:not(.is-animated).is-closed {
    display: none !important;
  }

  &__container {
    background: transparent;
  }

  &.is-animated {
    animation-duration: 1s;
  }

  &.is-animated:not(.is-closed) {
    animation-name: animate-height-increase;
  }

  &.is-closed.is-animated {
    animation-duration: $ads-alert-animation-duration;
    animation-name: animate-height-decrease;
    max-height: 0;
  }

  &.is-animated &__container {
    animation-duration: $ads-alert-animation-duration;
  }

  &.is-animated-up &__container {
    animation-name: animate-up;
  }

  &.is-animated-down &__container {
    animation-name: animate-down;
  }

  &.is-closed.is-animated &__container {
    opacity: 0;
  }

  &.is-closed.is-animated-down &__container {
    animation-name: animate-down-closed;
    transform: translateY(-$ads-alert-animation-offset);
  }

  &.is-closed.is-animated-up &__container {
    animation-name: animate-up-closed;
    transform: translateY($ads-alert-animation-offset);
  }

  &__text {
    color: inherit;
    font-family: var(--ads-font-family);
    font-size: 16px;
    margin: 0 auto;
    max-width: $ads-container-breakpoint-xl;
    padding: 16px 58px;
  }

  &__close {
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    fill: inherit;
    height: 44px;
    justify-content: center;
    left: var(--ads-alert-close-button-left, $ads-alert-close-button-left-ltr);
    position: absolute;
    right: var(--ads-alert-close-button-right, $ads-alert-close-button-right-ltr);
    text-overflow: clip;
    top: 4px;
    width: 44px;

    svg {
      height: 20px;
      width: 20px;
    }

    &:active {
      color: inherit;
    }
  }
}

:host(.is-success) .c-alert {
  background-color: var(--ads-alert-background-color-success, $ads-alert-background-color-success);
  color: var(--ads-alert-color-success, $ads-alert-color-success);
  fill: var(--ads-alert-color-success, $ads-alert-color-success);
}

:host(.is-warning) .c-alert {
  background-color: var(--ads-alert-background-color-warning, $ads-alert-background-color-warning);
  color: var(--ads-alert-color-warning, $ads-alert-color-warning);
  fill: var(--ads-alert-color-success, $ads-alert-color-success);
}

:host(.is-danger) .c-alert {
  background-color: var(--ads-alert-background-color-danger, $ads-alert-background-color-danger);
  color: var(--ads-alert-color-danger, $ads-alert-color-danger);
  fill: var(--ads-alert-color-success, $ads-alert-color-success);
}
